/**
 * Resolves which children are selected on a request form.
 * Manual toggles win; otherwise a deep-link childId or a single linked child.
 */
export function resolveSelectedChildIds(
    manualSelectedChildIds: number[] | null,
    childIdParam: string | undefined,
    childIds: number[],
): number[] {
    if (manualSelectedChildIds !== null) {
        return manualSelectedChildIds.filter((id) => childIds.includes(id));
    }

    if (childIdParam) {
        const parsed = Number(childIdParam);
        if (childIds.includes(parsed)) {
            return [parsed];
        }
    }

    if (childIds.length === 1) {
        return childIds;
    }

    return [];
}
